package com.oratakashi.web.resources

import com.varabyte.kobweb.compose.ui.graphics.Color

object R {
    enum class font {
        PoppinsRegular,
        PoppinsSemiBold,
        PoppinsMedium,
        PoppinsBold
    }

    enum class drawable(val link: String) {
        PHOTO("photo.png"),
        LINKEDIN("linkedin.png")
    }

    enum class colors(val value: Color) {
        BACKGROUND(Color.rgb(0xECF8FF)),
        CARD_BACKGROUND_LIGHT(Color.rgb(0xFFFFFF)),
        CARD_BACKGROUND_DARK(Color.rgb(0x111827)),
        SHADOW_COLORS(Color.rgb(0x1DA1F2)),

        PRIMARY_100(Color.rgb(0xD1E0FF)),
        PRIMARY_200(Color.rgb(0xB2CCFF)),
        PRIMARY_300(Color.rgb(0x84ADFF)),
        PRIMARY_400(Color.rgb(0x528BFF)),
        PRIMARY_500(Color.rgb(0x2970FF)),

        TERTIARY_300(Color.rgb(0xD0D5DD)),
        TERTIARY_400(Color.rgb(0x98A2B3)),
        TERTIARY_500(Color.rgb(0x667085)),

        ERROR_500(Color.rgb(0xF04438)),
    }

    object dimens {
        const val BORDER_RADIUS = 16
        const val MAX_CARD_WIDTH = 1000
        const val MAX_CARD_HEIGHT = 600
        const val ICON_SIZE = 24
        const val ICON_SIZE_LG = 32
    }

    object string {
        const val HOME_TEXT_ENG =
            "Hello, I'm Abdul Hafiidh, an Android Development expert with experience since 2019. My commitment to excellence is reflected in every project, supported by skills and dedication to meet client needs. With a strong educational background and practical experience, I am confident in delivering valuable technological innovations. I am open to collaboration and believe that together we can achieve outstanding results. Feel free to contact me to discuss your project further. Thank you."

        const val ABOUT_TEXT_CONTACT_ME_ENG = "Contact Me"
        const val ABOUT_TEXT_EDUCATION_ENG = "Education"
        const val ABOUT_TEXT_ENG =
            "Hello, let me introduce myself, Abdul Hafiidh, I am a software engineer who focuses on Android Development!"
    }
}